import { BASE_PARAMS } from '../constants/api'
import { api } from '.'

export const eduCommissions = {
  list: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: 'consolidated.commission_oo.list',
    }
    return api.get('/', { params })
  },
  getById: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: 'consolidated.commission_oo.get',
    }
    return api.get('/', { params })
  },
}
